import Axios from 'axios-observable';
import {AuthenticatedModel} from '@/models/authenticated.model';
import * as sweet from 'sweetalert2';
import {authState} from '@/utils/store-acessor';

const {
  VUE_APP_BASE_URL,
  VUE_APP_API_PATH,
  VUE_APP_AUTH_PATH,
  VUE_APP_CLIENT_SECRET,
  VUE_APP_CLIENT_ID,
} = process.env;

// @ts-ignore
export const BASE_URL = new URL(VUE_APP_BASE_URL);
// @ts-ignore
export const API_URL = new URL(VUE_APP_API_PATH, BASE_URL);
// @ts-ignore
export const AUTH_URL = new URL(VUE_APP_AUTH_PATH, BASE_URL);
export const CLIENT_SECRET = VUE_APP_CLIENT_SECRET;
export const CLIENT_ID = VUE_APP_CLIENT_ID;

const fetchTokenInStorage = (): string | undefined => {

  const saved = localStorage.getItem('credentials');
  const credentials: AuthenticatedModel = saved && JSON.parse(saved);

  return credentials?.access_token;
};


const options: sweet.SweetAlertOptions = {
  title: 'Ops..',
  text: 'I\'m sorry, for some reason it was not possible to contact the server, please try again later...',
  icon: 'error',
  confirmButtonColor: '#cf3134'
};

export interface AxiosHeader {
  'Content-type'?: 'application/json' | 'multipart/form-data';
  'Accept'?: 'application/json';
  'Access-Control-Allow-Origin'?: string | '*';
  'Authorization'?: string;
}

const axiosHeaders = (token?: string): AxiosHeader => {
  const headers: AxiosHeader = {
    'Content-type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }
  return headers
};

const multipartHeaders = (token?: string): AxiosHeader => {
  const headers: AxiosHeader = {
    'Content-type': 'multipart/form-data',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const publicUrl = API_URL.href + 'v1';
const authenticatedUrl = API_URL.href + 'v1/contestants';

const publicAxios: Axios = Axios.create({
  baseURL: publicUrl,
  headers: axiosHeaders(fetchTokenInStorage()),
});

const privateAxios = (): Axios => Axios.create({
  baseURL: authenticatedUrl,
  headers: axiosHeaders(fetchTokenInStorage()),
});

privateAxios().interceptors.request.use((config) => {
  return config;
}, (error) => {
  if (error?.status == 401) {
    authState.logout();
  }
  return Promise.reject(error);
});

// Add a response interceptor
privateAxios().interceptors.response.use((response) => {
  return response;
}, (error) => {
  return Promise.reject(error);
});

publicAxios.interceptors.request.use((config) => {
  return config;
}, (error) => {
  if (error.message === 'Network Error') {
    sweet.default.fire(options).then();
  }
  return Promise.reject(error);
});

// Add a response interceptor
publicAxios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.message === 'Network Error') {
    sweet.default.fire(options).then();
  } else {
    return Promise.reject(error);
  }
});

export const axiosMultipart: Axios = Axios.create({
  baseURL: publicUrl,
  headers: multipartHeaders(fetchTokenInStorage()),
});

export const axiosMultipartAuthenticated: Axios = Axios.create({
  baseURL: authenticatedUrl,
  headers: multipartHeaders(fetchTokenInStorage()),
});

export const axiosInstance = (): Axios => publicAxios;

export const axiosInstanceAuthenticated = () => privateAxios();
